import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import { useResponsive } from "../../hooks/use-responsive";

export default function HeroThree() {

  const mdUp = useResponsive("up", "md");


  return (

    <Grid
      container
      spacing={3}
      sx={{ justifyContent: "center", alignContent: "center" }}
    >
      {mdUp && (
        <Grid item xs={12} md={6}>
          <Typography
            component="span"
            className="HeroHeading"
          >
            IS YOUR CHILD LEARNING &nbsp;<span className="HeroHighlighted"  >DIGITAL SKILLS?</span>
          </Typography>

          <Box justifyContent='center' alignItems='center' mt='28px' >
            <Typography className="heroText" >
              Give your child the safe cloud pc for a bright future. Start their journey to mastering digital skills today!
            </Typography>
          </Box>

        </Grid>
      )}
      {mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_three.svg"
            alt="home_hero_three"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_three_sm.svg"
            alt="home_hero_three"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && (
        <Grid item xs={12} md={7} textAlign="center" >
          <Typography
            component="span"
            className="HeroHeading"
            textAlign={'center'}
          >
            IS YOUR CHILD LEARNING &nbsp;<span className="HeroHighlighted"  >DIGITAL SKILLS?</span>
          </Typography>

          <Box sx={{
            // mt: '18px',
            minHeight: '106px', // Set a minimum height for the Box
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}   >
            <Typography textAlign='center' className="heroText"
            >
              Give your child the safe cloud pc for a bright future. Start their journey to mastering digital skills today!
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}
